window.Discount ?= {}

DealEventPipe = require '../../../deal/frontend/event_pipe'

Discount.View = Backbone.View.extend
  el: "#discount-data, .discount-data"

  initialize: ->
    DealEventPipe.on "priceUpdate", (priceData) => @updateTiles priceData

  updateTiles: ({value, percent, savings, hideOriginalPriceAndDiscount}) ->
    @$("#discount-value, .discount-value").html value
    @$("#discount-percent, .discount-percent").html percent
    @$("#discount-you-save, .discount-you-save").html savings
    if hideOriginalPriceAndDiscount
      @$el.parents(".deal-discount").hide()
    else
      @$el.parents(".deal-discount").show()


module.exports = Discount
